import axiosInstance from "../lib/axios.instance";
import {
  IUserSignIn,
  ILoginResponse,
  IUser,
  IForgotPasswordRequest,
  IForgotPasswordResponse,
  IChangePasswordRequest,
  IChangePasswordResponse,
  IResetPasswordInput,
  IResetPasswordOutput,
  IRefreshTokenResponse,
} from "../types/auth.types";
import { getRefreshToken } from "../utils/storage.utils";

// Login function - only uses auth/sign-in endpoint
export const login = async (data: IUserSignIn): Promise<ILoginResponse> => {
  const { is_addon, ...loginData } = data;
  const response = await axiosInstance.post<ILoginResponse>("auth/sign-in", loginData, {
    params: {
      is_addon,
    },
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

  return response.data;
};

// Get user function
export const getUser = async (): Promise<IUser> => {
  const response = await axiosInstance.get<IUser>("auth/user");
  return response.data;
};

// Send reset password email (Step 1 of forgot password flow)
export const sendResetPasswordEmail = async (
  data: IForgotPasswordRequest
): Promise<IForgotPasswordResponse> => {
  const response = await axiosInstance.post<IForgotPasswordResponse>("auth/forgot-password", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

// Reset password with token (Step 3 of forgot password flow - used via web link)
export const resetPasswordWithToken = async (
  data: IResetPasswordInput
): Promise<IResetPasswordOutput> => {
  const response = await axiosInstance.put<IResetPasswordOutput>("auth/reset-password", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

// Change password (for authenticated users who know their old password)
export const changePassword = async (
  data: IChangePasswordRequest
): Promise<IChangePasswordResponse> => {
  const response = await axiosInstance.post<IChangePasswordResponse>("auth/change-password", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

// Refresh token
export const refreshToken = async (): Promise<IRefreshTokenResponse> => {
  const token = await getRefreshToken();
  const response = await axiosInstance.post<IRefreshTokenResponse>(
    "auth/refresh",
    { refresh_token: token },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};
